import React from 'react';
// Design system first
import './siteShell.css';
import { AudienceProvider } from '../context/AudienceContext';
import { CartProvider } from '../context/CartContext';
import AppRouter from './router';

const App: React.FC = () => {
  return (
    <AudienceProvider>
      <CartProvider>
        <AppRouter />
      </CartProvider>
    </AudienceProvider>
  );
};

export default App;